import { QueryClient } from '@tanstack/react-query';
import { mutationReportOwner, runWithNetworkReportScope } from './networkReportScope';

const scopedFunctions = new WeakSet<(...args: never[]) => unknown>();

export class NetworkQueryClient extends QueryClient {
  override defaultQueryOptions: QueryClient['defaultQueryOptions'] = (options) => {
    const result = super.defaultQueryOptions(options);
    const queryFn = result.queryFn;
    if (typeof queryFn === 'function' && !scopedFunctions.has(queryFn)) {
      result.queryFn = (context) =>
        runWithNetworkReportScope(
          context.client.getQueryCache().find({ queryKey: context.queryKey, exact: true }),
          () => queryFn(context)
        );
      scopedFunctions.add(result.queryFn);
    }
    return result;
  };

  override defaultMutationOptions: QueryClient['defaultMutationOptions'] = (options) => {
    const result = super.defaultMutationOptions(options);
    const mutationFn = result.mutationFn;
    if (mutationFn && !scopedFunctions.has(mutationFn)) {
      result.mutationFn = (variables, context) =>
        runWithNetworkReportScope(mutationReportOwner(context), () =>
          mutationFn(variables, context)
        );
      scopedFunctions.add(result.mutationFn);
    }
    return result;
  };
}
